import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Handshake } from "@phosphor-icons/react";
import { useContent } from "../context/ContentContext";
import { resolveImg } from "../lib/api";

export const PartnerSection = () => {
  const { content, settings } = useContent();
  if (!settings.partner_enabled) return null;

  const url = content.partner_url || "#";
  const name = content.partner_name || "Our Partner";
  const nameWords = name.trim().split(/\s+/);
  const nameLines = nameWords.length > 2
    ? [nameWords.slice(0, -2).join(" "), nameWords.slice(-2).join(" ")]
    : [name];

  return (
    <section className="bg-white py-20 md:py-28" data-testid="partner-section">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="relative overflow-hidden border border-navy/10 bg-navy-dark"
        >
          <div className="absolute inset-0 noise-overlay" />
          {/* Ray White signature yellow accent bar */}
          <div className="absolute left-0 top-0 h-full w-2 bg-[#FFE600]" />

          <div className="relative grid md:grid-cols-2 gap-8 md:gap-12 items-center p-8 md:p-14">
            {/* Logo / badge */}
            <div className="flex flex-col items-center md:items-start">
              {content.partner_logo ? (
                <>
                  <img src={resolveImg(content.partner_logo)} alt={name} className="max-h-40 w-auto object-contain shadow-xl" data-testid="partner-logo" />
                  <div className="mt-3 text-white text-lg md:text-xl font-medium whitespace-nowrap" data-testid="partner-office">New Plymouth</div>
                </>
              ) : (
                <div className="bg-[#FFD200] px-10 py-7 md:px-14 md:py-9 text-center shadow-xl">
                  <div className="font-heading text-4xl md:text-5xl font-bold text-white tracking-tight leading-none">Ray White</div>
                  <div className="mt-2 text-sm md:text-base font-medium text-white whitespace-nowrap">New Plymouth</div>
                </div>
              )}
            </div>

            {/* Text */}
            <div>
              <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-semibold text-[#FFE600]">
                <Handshake size={16} weight="fill" /> Proudly partnering with
              </span>
              <h2 style={{ fontFamily: '"Poppins", sans-serif' }} className="italic font-extrabold text-3xl md:text-4xl lg:text-5xl text-white tracking-tight mt-4 leading-[1.05]">
                {nameLines.map((l, i) => <span key={i} className="block">{l}</span>)}
              </h2>
              <p className="mt-5 text-white/70 leading-relaxed">{content.partner_blurb}</p>
              {content.partner_url && (
                <a
                  href={url}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="partner-cta"
                  className="group mt-7 inline-flex items-center gap-2 bg-[#FFE600] text-black font-semibold px-7 py-3.5 rounded-sm transition-transform hover:-translate-y-0.5"
                >
                  Visit {name}
                  <ArrowUpRight size={20} weight="bold" className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                </a>
              )}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
